import { render } from "./CareerDetail.vue?vue&type=template&id=4e6abbf5&scoped=true"
import script from "./CareerDetail.vue?vue&type=script&lang=ts"
export * from "./CareerDetail.vue?vue&type=script&lang=ts"

import "./CareerDetail.vue?vue&type=style&index=0&id=4e6abbf5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e6abbf5"

export default script